(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('incident-type', {
                parent: 'entity',
                url: '/incident-type',
                data: {
                    authorities: [],
                    pageTitle: 'IncidentTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/incident-type/list/incident-type.html',
                        controller: 'IncidentTypeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_TYPE, access);
                }]
            });
    }
})();
